import { TextArea } from "components/ui/inputs/TextArea"
import { ButtonSend } from "components/ui/buttons/ButtonSend/ButtonSend"
import { TOnChangeInput } from "types/default.type"
import { KeyboardEvent } from "react"
import style from "./QuestionInput.module.scss"

const { questionInput } = style

type Props = { onChange: (e: TOnChangeInput) => void; sendMessageHandle: () => void; value: string; disabled?: boolean }

export const QuestionInput = ({ onChange, sendMessageHandle, value, disabled }: Props) => {
	const handleKeyDown = (e: KeyboardEvent<HTMLTextAreaElement>) => {
		// Send message when Enter is pressed without Shift key
		if (e.key === "Enter" && !e.shiftKey && !disabled) {
			e.preventDefault() // Prevent new line
			sendMessageHandle()
		}
	}

	return (
		<div data-testid="input-question" className={questionInput}>
			<TextArea
				minRows={1}
				value={value}
				onChange={onChange}
				onKeyDown={handleKeyDown}
				placeholder="Type your question here"
			/>
			<ButtonSend onClick={sendMessageHandle} submittable={!disabled} />
		</div>
	)
}
